class Submission {
  constructor (data) {
    this.id = data ? data.id : ''
    this.user_name = data ? data.user.name : ''
    this.user_email = data ? data.user.email : ''
    this.artist_name = data ? data.artist_name : ''
    this.social_username = data ? data.social_username : ''
    this.spotify_url = data ? data.spotify_url : ''
    this.status = data ? data.status : ''
    this.submitted_at = data ? data.created_at : ''
  }
}

export default Submission



// WEBPACK FOOTER //
// ./src/models/submission.js